import {apiUri} from "../../../../config";
import axios from "axios";
import { ACEALERT } from "../../../../ace/redux/actions";

export const LOAD_CASE = 'LOAD_CASE';
export const LOAD_SETTLEMENTRATE = 'LOAD_SETTLEMENTRATE';
export const LOAD_SETTLEMENTRATEBANDS = 'LOAD_SETTLEMENTRATEBANDS';
export const LOAD_PURCHASEDETAILS = 'LOAD_PURCHASEDETAILS';

const getProperDate = data => {
 
	var data1 =[]
		for(let i=0;i<3;i++){
			data1[i]=data[i]
		}
		if (data1) {
			var date = new Date(data1);
			var year = date.getFullYear();
			var month = (1 + date.getMonth()).toString().padStart(2, "0");
			var day = date
				.getDate()
				.toString()
				.padStart(2, "0");
			return month + "/" + day + "/" + year;
		} else {
			return "";
		}

	};
	
const loadCaseDamages = (basicDamages, caseId) => {
	return {
		type: LOAD_CASE,
		basicDamages: basicDamages,
		caseId: Number(caseId)
	}
};

const loadCurrentSettlementRateBands = (currentSettlementRateBands) => {
	return {
		type: LOAD_SETTLEMENTRATEBANDS,
		currentSettlementRateBands: currentSettlementRateBands
	}
};
const loadCurrentSettlementRate = (currentSettlementRate) => {
	return {
		type: LOAD_SETTLEMENTRATE,
		currentSettlementRate: currentSettlementRate
	}
};

const loadPurchaseDetails = (purchaseDate, caseId) => {
	return {
		type: LOAD_PURCHASEDETAILS,
		purchaseTime: getProperDate(purchaseDate.purchaseTime),
		purchaseType: purchaseDate.purchaseType
	}
};

export const fetchCurrentSettlementRateBands = () => {
	return dispatch => {
		return axios.get(apiUri+"/SettlementRate/currentBand")
			.then(json => dispatch(loadCurrentSettlementRateBands(json.data.content) ))
	}
};

export const fetchCurrentSettlementRate = () => {
	return dispatch => {
		return axios.get(apiUri+"/SettlementRate/current")
			.then(json => dispatch( loadCurrentSettlementRate(json.data.content)))
	}
};

export const fetchCaseDamages = (caseId) => {
	if (caseId === null) {
		let defaultJson = {
			"classPeriodTradingStats": null,
			"marketCapitalizationLosses": null,
			"statResidualReturns": null,
			"stockPrices": null,
			"fillingName": null,
			"docketNumber": null,
			"nopslraFlag": false,
			"settlementRate": 0.1024,
			"availablePurchaseLevels": [
			    "NO_EMBARGO"
			]
		};
		return dispatch => {
			dispatch(loadCaseDamages(defaultJson, 0))
		}
	}

	return dispatch => {
		return axios.get(apiUri+"/cases/" + caseId)
			.then(json => dispatch(loadCaseDamages(json.data.content, caseId)))
	}
};

export const fetchCasePurchaseDetails = (caseId) => {
	return dispatch => {
		return axios.get(apiUri+"/purchases/History/" + caseId)
			.then(json =>dispatch(loadPurchaseDetails(json.data.content, caseId)))
	}
};
export const send_email = (alertData) => {
	  return (dispatch) => {
		  dispatch({type: ACEALERT, alertType:alertData});
	  }
  }




// WEBPACK FOOTER //
// ./src/components/DamageReports/BasicDamageReport/store/actions.js